
import { ContactAddressRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CONTACT_ADDRESS_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleGoogleMapClick: (
    event: React.MouseEvent<HTMLDivElement>,
    latitude: number | null,
    longitude: number | null
  ) => void,
  handleWhatsAppClick: (
    event: React.MouseEvent<HTMLDivElement>,
    address: string,
    latitude: number | null,
    longitude: number | null
  ) => void,
  handleViberClick: (
    event: React.MouseEvent<HTMLDivElement>,
    address: string,
    latitude: number | null,
    longitude: number | null
  ) => void,
  handleCopyLinkClick: (
    event: React.MouseEvent<HTMLDivElement>,
    latitude: number | null,
    longitude: number | null
  ) => void,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLDivElement>,
    id: string
  ) => void
): Column[] => {
  return [
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactAddressRow) => {

        return (
          <TableIcon imageUrl="/media/images/address-icon.svg" />
        );
      },
    },
    {
      title: "Država",
      field: "country",
      type: ColumnTypes.string,
    },
    {
      title: "Grad",
      field: "city",
      type: ColumnTypes.string,
    },
    {
      title: "Općina",
      field: "state",
      type: ColumnTypes.string,
    },
    {
      title: "Poštanski broj",
      field: "postalCode",
      type: ColumnTypes.string,
    },
    {
      title: "Adresa 1",
      field: "line1",
      type: ColumnTypes.string,
    },
    {
      title: "Adresa 2",
      field: "line2",
      type: ColumnTypes.string,
    },
    {
      title: "Opis",
      field: "description",
      type: ColumnTypes.string,
    },
    {
      title: "Primarna",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactAddressRow) => {
        return <Badge text={row.primary ? "DA" : "NE"} variant={row.primary ? "success" : "danger"} />;
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactAddressRow) => {
        const fullAddress = `${row.line1}, ${row.city}, ${row.postalCode}, ${row.state}, ${row.country}`;
        const hasCoordinates = row.latitude !== null && row.longitude !== null;

        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            {hasCoordinates && (
              <>
                {hasCoordinates && (
                  <ButtonMenuItem
                    startIcon="/media/icons/map.svg"
                    className="text-slate-600 hover:bg-blue-100"
                    onClick={(e) => handleGoogleMapClick(e, row.latitude, row.longitude)}
                  >
                    Otvori google kartu
                  </ButtonMenuItem>
                )}

                <ButtonMenuItem
                  startIcon="/media/icons/whatsapp.svg"
                  className="text-slate-600 hover:bg-blue-100"
                  onClick={(e) => handleWhatsAppClick(e, fullAddress, row.latitude, row.longitude)}
                >
                  Podijeli na WhatsApp
                </ButtonMenuItem>
                <ButtonMenuItem
                  startIcon="/media/icons/viber.svg"
                  className="text-slate-600 hover:bg-blue-100"
                  onClick={(e) => handleViberClick(e, fullAddress, row.latitude, row.longitude)}
                >
                  Podijeli na Viber
                </ButtonMenuItem>
                <ButtonMenuItem
                  startIcon="/media/icons/copy.svg"
                  className="text-slate-600 hover:bg-blue-100"
                  onClick={(e) => handleCopyLinkClick(e, row.latitude, row.longitude)}
                >
                  Kopiraj link
                </ButtonMenuItem>
              </>
            )}
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              className="text-slate-600 hover:bg-blue-100"
              onClick={(e) => handleDeleteClick(e, row.id)}

            >
              Obriši
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];
};



